const Sdata = [
	{
		id: 1,
		title: "Free Consultation",
		desc: "Consultation makes the life of the user to decide what kind of design and materials that fit with their budget",
		cover: "./images/SlideCard/davies.png",
	},
	{
		id: 2,
		title: "Free Consultation",
		desc: "Consultation makes the life of the user to decide what kind of design and materials that fit with their budget",
		cover: "./images/SlideCard/Copy of ss standard JOSE starex hammer ₱125.png",
	},
	{
		id: 3,
		title: "Free Consultation",
		desc: "Consultation makes the life of the user to decide what kind of design and materials that fit with their budget",
		cover: "./images/SlideCard/Copy of ii mid utility box ordinary ₱18.png",
	},
	{
		id: 4,
		title: "Free Consultation",
		desc: "Consultation makes the life of the user to decide what kind of design and materials that fit with their budget",
		cover: "./images/SlideCard/Copy of ww high brass wood screw size- 6x1 ₱6.00.png",
	},
];
export default Sdata;
